<template>
  <div class="ab-target__set">
    <div class="title__wrap">
      <span class="title">{{ $t('ab.addOrEdit.registration.target.title') }}</span>
      <span class="optional">{{ $t('ab.addOrEdit.registration.target.option') }}</span>
      <span class="description">{{ $t('ab.addOrEdit.registration.target.description') }}</span>
    </div>
    <div class="info-setting__wrap">
      <div class="page-division__wrap">
        <div class="a-label">
          <i>A</i>
        </div>
        <div class="b-label">
          <i>B</i>
        </div>
      </div>
      <div class="arrow__wrap">
        <img v-if="targetListLength >= 2" src="@/assets/img/arrow/3depth/conversion-arrow-ab-line-1@3x.png"
          class="third-depth" />
        <img v-if="targetListLength === 1" src="@/assets/img/arrow/2depth/conversion-arrow-ab-line-1-b@3x.png"
          class="two-depth" />
        <img v-if="targetListLength !== 1" src="@/assets/img/arrow/3depth/conversion-arrow-ab-line-2@3x.png"
          class="one-depth" />
        <img v-if="targetListLength === 1" src="@/assets/img/arrow/2depth/conversion-arrow-ab-line-3-b@3x.png"
          class="two-depth" />
        <img v-if="targetListLength >= 2" src="@/assets/img/arrow/3depth/conversion-arrow-ab-line-3@3x.png"
          class="third-depth" />
      </div>
      <div class="target__wrap">
        <div class="target-base-wrap">
          <template v-for="(item, idx) in targetList">
              <div class="target-inner__wrap" v-if="!isEditMode ? true : !item.deleted" :key="item.regDate">
                <div class="target">
                  <div class="thumbnail">
                    <img v-if="item.imgSrc" class="img" :src="item.imgSrc" />
                    <i v-else class="icon icon-empty-image" />
                  </div>
                  <div class="info">
                    <div class="input_wrap" :class="{'error': item.error}">
                      <div class="ui-selectbox-deleted" v-if="!isEditMode && item.deleted">
                        <p class="selectbox-inner">
                          <span class="ellipsis">[{{item.matchType | matchType}}] {{item.pageName}}</span>
                          <i class="icon icon--drop-down"></i>
                        </p>
                      </div>
                      <ui-selectbox v-else :items="getAvailableApplies(item)" v-model="item.aid" width="100%" max-width="600px" min-width="470px"
                        :disabled="!isEditMode" @input="onSelectTarget(item, idx)" />
                        <span class="error" v-if="item.error">{{ $t('ab.addOrEdit.registration.target.error') }}</span>
                    </div>
                    <button class="icon icon--trash" @click="onTargetDeleteClick(idx)" v-if="isEditMode"></button>
                  </div>
                </div>
              </div>
          </template>
        </div>
        <div v-if="isEditMode && targetListLength < 3" class="target-inner__wrap" :class="{ base: targetListLength !== 0 }">
          <div class="target">
            <div class="thumbnail">
              <i class="icon icon-empty-image" />
            </div>
            <div class="info" :class="{ disabled : !isAddAvailable}" @click="onTargetAddClick" @mouseenter="showTargetTooltip = true"
              @mouseleave="showTargetTooltip = false">

              <div class="add">
                <i class="icon icon--plus-black"></i>
                <span class="text">
                  {{ $t('ab.addOrEdit.registration.add.placeholder') }}
                </span>
                <ui-tooltip v-if="showTargetTooltip && !isAddAvailable" arrowCenter noApplyCenterAnimate>
                  <span v-html="$t('ab.addOrEdit.registration.target.tooltip')" />
                </ui-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiSelectbox from '@/components/ui/UiSelectbox'
import UiTooltip from '@/components/ui/UiTooltip'
import { mapState } from 'vuex'
import { getPageListBySid } from '@/api/apply'
import { getCaptureImageUrl } from '@/api/report'

export default {
  name: 'ABreportConversionTarget',
  components: {
    UiSelectbox,
    UiTooltip
  },
  props: [
    'list',
    'isEditMode',
    'type'
  ],
  watch: {
  },
  data () {
    return {
      showTargetTooltip: false,
      isReady: false,
      applies: [],
      targetList: [],
      isLoaded: false
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'reportPeriod',
      'captureImageTimestamp'
    ]),
    targetListLength () {
      let count = this.targetList.filter(item => !this.isEditMode ? true : !item.deleted).length
      if (!this.isEditMode) {
        count = count - 1
      }
      return count
    },
    usedAidSet () {
      const aidSet = {}

      this.targetList.forEach(item => {
        if (item.aid || item.deleted) {
          aidSet[item.aid] = true
        }
      })
      return aidSet
    },
    isAddAvailable () {
      return !(this.targetList.length === this.applies.length || this.applies.length === 0)
    }
  },
  methods: {
    async setImagePath () {
      for (let i = 0; i < this.targetList.length; i++) {
        this.$set(this.targetList, i, {
          ...this.targetList[i],
          imgSrc: await this.getImagePath(this.targetList[i].aid)
        })
      }
    },
    async imageExistCheck (url) {
      const http = new XMLHttpRequest()
      http.open('GET', url, false)
      http.send()
      return http.status !== 404
    },
    captureImageParams (aid, device) {
      return {
        aid: aid,
        device: device,
        startDate: this.reportPeriod.start,
        endDate: this.reportPeriod.end
      }
    },
    async getImagePath (aid) {
      let deviceList = ['desktop', 'phone', 'tablet']
      if (this.applyData.bMobile) {
        deviceList = ['phone', 'desktop', 'tablet']
      }

      let imageUrl = ''

      let isValidImg = false

      for (const device of deviceList) {
        if (!isValidImg) {
          const params = this.captureImageParams(aid, device)
          const imgUrl = await getCaptureImageUrl(params, this.captureImageTimestamp)

          if (imgUrl && await this.imageExistCheck(imgUrl)) {
            imageUrl = imgUrl
            isValidImg = true
          }
        }
      }

      return imageUrl
    },
    async onSelectTarget (target, idx) {
      const aid = target.aid

      this.$set(this.targetList, idx, {
        ...this.targetList[idx],
        aid: aid,
        imgSrc: aid ? await this.getImagePath(target.aid) : '',
        isImg: !!aid,
        error: false,
        deleted: false
      })

      this.$emit('onTargetUpdate', this.targetList)
    },
    getAvailableApplies (currentItem) {
      if (!this.applies) {
        return []
      }

      const currentAid = currentItem ? currentItem.aid : null
      const items = this.applies.filter(item => {
        return (item.aid === currentAid || !this.usedAidSet[item.aid]) && item.aid !== this.applyData._id
      }).map(item => {
        const matchTypeStr = this.$options.filters.matchType(item.matchType)
        return {
          value: item.aid,
          text: `[${matchTypeStr}] ${item.pageName}`,
          pageName: item.pageName
        }
      }).sort((a, b) => {
        return a.pageName.localeCompare(b.pageName)
      })
      items.unshift({
        value: '',
        text: this.$t('funnel.registration.form.selectPageUrl')
      })
      return items
    },
    sortItems () {
      this.items.sort((a, b) => {
        const aValue = String(a[this.sortColumn])
        const bValue = String(b[this.sortColumn])
        let result = aValue.localeCompare(bValue)

        if (!this.isSortAsc) {
          result = -result
        }
        return result
      })
    },
    getAidList () {
      getPageListBySid(this.applyData.sid).then(items => {
        for (const item of items) {
          const applies = item.applies.filter(item => {
            return item.state === 'run' && item.id !== this.applyData._id
          }).map(item => {
            return {
              aid: item.id,
              pageName: item.pageName,
              matchType: item.matchType,
              url: item.url
            }
          })
          this.applies = this.applies.concat(applies)
        }
      })
    },
    onTargetAddClick () {
      if (this.isAddAvailable) {
        const idx = this.targetList.length

        this.$set(this.targetList, idx, {
          ...this.targetList[idx],
          aid: '',
          regDate: new Date().toISOString(),
          imgSrc: '',
          isImg: false,
          sid: this.applyData.sid
        })

        this.$emit('onTargetUpdate', this.targetList)
      }
    },
    onTargetDeleteClick (idx) {
      if (this.targetList[idx].state) {
        this.$set(this.targetList, idx, {
          ...this.targetList[idx],
          deleted: true
        })
      } else {
        this.$delete(this.targetList, idx)
      }

      this.$emit('onTargetUpdate', this.targetList)
    }
  },
  async created () {
    await this.getAidList()
    setTimeout(async () => {
      if (this.list.length > 0) {
        this.targetList = [...this.list]

        if (this.targetList.length > 0) {
          await this.setImagePath()
        }
      }
      this.isLoaded = true
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.ab-target__set {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 1000px;
  margin-top: 30px;
  padding: 25px;
  border-radius: 14px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;

  .title__wrap {
    display: flex;
    align-items: flex-end;
    height: 16px;

    .title {
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #2f2f2f;
    }

    .optional {
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #666;
      margin-left: 10px;
    }

    .description {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #767676;
      margin-left: 15px;
    }
  }

  .info-setting__wrap {
    display: flex;
    justify-content: center;
    padding: 60px 95px 45px;

    .page-division__wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 5px;

      .a-label {
        position: relative;
        width: 38px;
        height: 38px;
        border-radius: 7px;
        background-color: #9fce12;

        i {
          @include positionXYcenter;
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
        }
      }

      .b-label {
        position: relative;
        width: 38px;
        height: 38px;
        border-radius: 7px;
        background-color: #1199af;

        i {
          @include positionXYcenter;
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }

    .arrow__wrap {
      min-width: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 13px;

      .one-depth {
        width: 103px;
        height: 12px;
        margin-top: -8px;
        margin-bottom: -8px;
      }

      .two-depth {
        width: 103px;
        height: 95px;
        margin-top: -3px;
      }

      .third-depth {
        width: 103px;
        height: 185px;
      }
    }

    .target__wrap {
      display: flex;
      flex-direction: column;
      margin: 0px 65px 0px 20px;

      .target-base-wrap {
        display: flex;
        flex-direction: column;
        row-gap: 40px;
      }

      .target-inner__wrap {
        display: flex;
        flex-direction: column;

        .target {
          display: flex;
          align-items: center;

          .thumbnail {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f4f4f4;
            width: 140px;
            height: 140px;
            object-fit: cover;
            object-position: 0 0;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12), 0 4px 7px -2px rgba(0, 0, 0, 0.15);
            border-radius: 5px;
            border: 1px #bbb;
            img {
              display: inline-block;
            }
            .icon-empty-image {
              width: 32px;
              height: 32px;
              background-image: url(../../assets/img/icon-empty-image.svg);

              &.deleted {
                background-image: url(../../assets/img/icon-deleted-image.svg);
              }
            }
          }

          .info {
            position: relative;
            display: flex;
            align-items: center;
            margin-left: 20px;
            color: black;
            width: calc(100% - 150px);
            cursor: pointer;
            .input_wrap {
              width: 470px;
              &.error {
                /deep/ .item--wrap {
                  border-color: #e60724;
                }
              }
              .ui-selectbox-deleted {
                width: 100%;
                height: 38px;
                line-height: 36px;
                border-radius: 6px;
                border: solid 1px #d7d7d7;
                background-color: #e6e6e6;
                .selectbox-inner{
                  padding-left: 15px;
                  font-size: 14px;
                  color: #999;
                  span {
                    display: block;
                    margin-right: 35px;
                  }
                  i {
                    position: absolute;
                    top: 30%;
                    right: 12px;
                    opacity: 0.3;
                  }
                }
              }
            }

            .icon--trash {
              width: 32px;
              height: 32px;
              margin-left: 2px;
              border-radius: 100%;
              background-position: center;

              &:hover {
                @include hoverStyle;
              }
            }

            .add {
              width: calc(100% - 34px);
              height: 38px;
              color: #bbbbbb;
              background-color: #f4f4f4;
              border-radius: 7px;
              border: dashed 1px #bbb;
              text-align: center;
              line-height: 38px;
              max-width: 600px;
              min-width: 470px;

              & .text {
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: normal;
                color: #444;
                vertical-align: middle;
                position: relative;
              }

              .icon--plus-black {
                margin-left: -10px;
                vertical-align: middle;
              }
            }

            .bubble {
              top: -86px;
              left: 50%;
              transform: translate(-50%, 0);
              line-height: 1;
            }

            div {
              width: 100%;
              & span.error {
                font-size: 12px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #e60724;
                position: absolute;
                top: 43px;
                left: 6px;
              }
            }

            &.disabled {
              & .icon,
              & .text,
              {
                opacity: 0.4;
                cursor: initial;
              }
            }
          }

          .img {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f4f4f4;
            width: 140px;
            height: 140px;
            object-fit: cover;
            object-position: 0 0;
            border-radius: 5px;
            border: 1px #bbb;
          }
        }

        .inner {
          margin-top: 40px;
        }
      }

      .base {
        margin-top: 40px;
      }
    }
  }
}</style>
